import { routingProfileServiceEnvironment } from '../routing-profile-service-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { routingProfileSchema } from '../schemas/routing-profile.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Get an existing Routing Profile by its ID
 * @param routingProfileId ID of the Routing Profile
 * @returns The Routing Profile
 */
export function getRoutingProfilesId(this: unknown, routingProfileId: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          routingProfileServiceEnvironment.resolve(this).routingProfilesUrl
        }/${encodeURIComponent(routingProfileId)}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        data: routingProfileSchema,
      })
    )
  );
}
